import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-swj",
  "use": "icon-swj-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-swj\"><path d=\"M512 96a416 416 0 1 1 0 832 416 416 0 0 1 0-832z m0 64a352 352 0 1 0 0 704 352 352 0 0 0 0-704z m0 35.2L828.8 512 512 828.8 195.2 512 512 195.2z m0 90.496L285.696 512 512 738.304 738.304 512 512 285.696z\" p-id=\"6139\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol